module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/aq134-39c6a2c3f15ca0335d686addff7c47b3.jpg";